import { render, staticRenderFns } from "./GrupoRotaAssociacaoPage.vue?vue&type=template&id=4cb4385f"
import script from "./GrupoRotaAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./GrupoRotaAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports